import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import {Feature} from "ol";
import {Fill, Icon, Stroke, Style} from "ol/style";
import {WKT} from "ol/format";
import {removeLayer, setVisibleByLayerName} from "@/helpers/ol/ol-layer-helper";
import kleinoog from '../../../assets/img/kleinoog.png'

import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";

export function showPluginOnMap(source, origin, rotate_angle, visible) {

    const wkt = new WKT()
    let geometry = wkt.readGeometry(source);
    geometry.rotate(2 * Math.PI * rotate_angle / 360 , origin.getCoordinates());

    origin = origin.transform( 'EPSG:28992', getViewProjectionName())
    geometry = geometry.transform( 'EPSG:28992', getViewProjectionName())

    const cuttingSurface = new Feature({
        geometry: geometry
    });
    cuttingSurface.setStyle(
        new Style({
            fill: new Fill({
                color: 'rgba(85,85,255,0.2)'
            }),
            stroke: new Stroke({
                color: 'rgb(85,85,255)',
                width: 1,
            }),
        })
    );

    const cuttingEye = new Feature({
        geometry: origin,
    });

    cuttingEye.setStyle(
        new Style({
            image: new Icon({
                src: kleinoog
            }),
        })
    );

    const vectorLayer = new VectorLayer({
        altitudeMode: 'clampToGround',
        name: 'pluginLocation',
        zIndex: 1000,
        visible: visible,
        source: new VectorSource({
            features: [cuttingSurface, cuttingEye],
        }),
    });

    removeCycloramaPlugin()

    window.map.addLayer(vectorLayer)
}

export function removeCycloramaPlugin() {

    removeLayer('pluginLocation', false)
}

export function toggleCycloramaPlugin(visible = false) {
    setVisibleByLayerName('pluginLocation', visible)
}
